export default __webpack_public_path__ + "static/media/learn-opportunities.477963a0.jpg";